import { createSelector } from "reselect";
import { AppState } from "../types";

// TODO(cochamberlain): Pull from session.
const getSessionState = (state: AppState) => state.session;
const getNotebookState = (state: AppState) => state.notebook;

const getUser = createSelector([getSessionState], session => session.user);

const getUserId = createSelector([getUser], user =>
  user === null ? null : user.id
);

// TODO(cochamberlain): Rename to getOwner to keep in line with reselect docs.
export const selectOwner = createSelector(
  [getNotebookState],
  notebook => notebook.owner
);

const getOwnerId = createSelector([selectOwner], owner => owner.userId);

export const getIsOwner = createSelector(
  [getUserId, getOwnerId],
  (userId, ownerId) =>
    userId === null || ownerId === null ? false : userId === ownerId
);
